import React, { useState } from 'react'
import PropTypes from 'prop-types'
import TodayIcon from '@mui/icons-material/Today'
import './index.scss'
import DateRangePicker from './DatePicker'
import moment from 'moment'

import PrimaryOutlineButton from '../../../Buttons/PrimaryOutlineButton'
import PopHover from '../../../PopHover'
import ActionButtons from '../../../ActionButton'

export default function DateCell({ filterStateChanged }) {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'dateRangePicker' : undefined
  const dateForm = (date) => moment(date).format('DD MMM YYYY')
  const [state, setState] = useState(new Date())
  const onCancel = () => {
    filterStateChanged('dateLivraison', null)
    setState(new Date())
    handleClose()
  }
  const onApply = () => {
    const date = moment(state).format('DD-MM-YYYY')

    filterStateChanged('dateLivraison', date)
    handleClose()
  }

  return (
    <>
      <PrimaryOutlineButton
        onClick={(event) => setAnchorEl(event.currentTarget)}
        content={
          <span style={{ padding: 5 }}>
            {'Date Livraison' + ' : ' + dateForm(state)}
          </span>
        }
        icon={<TodayIcon />}
      />
      <PopHover
        open={open}
        id={id}
        anchorEl={anchorEl}
        onClose={handleClose}
        content={<DateRangePicker state={state} setState={setState} />}
        actionButtons={
          <ActionButtons onApply={onApply} onCancel={onCancel} isProgrammer={true} />
        }
        className="pophover-container-date pophover-container"
      />
    </>
  )
}
DateCell.propTypes = {
  filterStateChanged: PropTypes.func,
}
